import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${props => (props.theme.isMobile ? 16 : 24)}px;
`;

const UpdatedAt = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 12px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 100%;
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
`;

export default function Compliance({ fund }) {
  const { qandasUpdatedAt } = fund;
  const timestamp = moment(qandasUpdatedAt);

  return (
    <Container>
      <UpdatedAt>{`updated ${timestamp.format('Do MMM, YY')}`}</UpdatedAt>
    </Container>
  );
}

Compliance.propTypes = {
  fund: PropTypes.shape({
    qandasUpdatedAt: PropTypes.string,
  }).isRequired,
};
